import { render, staticRenderFns } from "./AddAmcPlan.vue?vue&type=template&id=030825ec&scoped=true"
import script from "./AddAmcPlan.vue?vue&type=script&lang=js"
export * from "./AddAmcPlan.vue?vue&type=script&lang=js"
import style0 from "./AddAmcPlan.vue?vue&type=style&index=0&id=030825ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030825ec",
  null
  
)

export default component.exports